import * as React from 'react';

interface PricingDropDownProps {
  title: string;
  value: number | string;
  options: any[];
  setValue: (v) => void;
}

export const PricingDropDown = ({ value, setValue, options, title }: PricingDropDownProps) => {
  const handleChange = (e) => {
    const parsedValue = parseInt(e.target.value, 10);
    setValue(Number.isNaN(parsedValue) ? e.target.value : parsedValue);
  };

  return (
    <div className="pricing-drop-down">
      <p className="bold-800 mb-10">{title}</p>
      <div className="select-wrapper mr-10">
        <select
          value={value}
          onChange={handleChange}
        >
          {options}
        </select>
      </div>
    </div>
  );
};
